import { connect } from "react-redux";
import { AppState } from "../../../store/AppState";
import OrganizationUtils from "../../../utils/organization";
import ClientsCard, {
  ClientsCardProps as _ClientsCardProps
} from "./clients-card-view";

import {
  PickReduxDispatchProps,
  PickReduxStateProps
} from "../../../util/typeUtil";
import { listOrganizationClients } from "../../../actions";
import InProgressUtils from "../../../utils/in-progress";
import { ActionSender } from "../../../model/ActionSender";
import { addSenderArgument } from "../../../actions/actionHelpers";

export interface ClientsCardProps
  extends Omit<_ClientsCardProps, "clients" | "isReady"> {}

// Input props provided to the wrapped component by this connect component, using mapStateToProps
type ReduxStateProps = PickReduxStateProps<_ClientsCardProps, ClientsCardProps>;

// Dispatch props provided to the wrapped component by this connect component
type ReduxDispatchProps = PickReduxDispatchProps<
  _ClientsCardProps,
  ClientsCardProps
>;

const sender: ActionSender = { key: "clientGroupsCard" };

function mapStateToProps(state: AppState): ReduxStateProps {
  return {
    clients: OrganizationUtils.selectOrganizationClients(state),
    isReady: InProgressUtils.selectNotInProgress(sender.key, state)
  };
}

function areStatesEqual(next: AppState, prev: AppState): boolean {
  return (
    OrganizationUtils.compareOrganizationClientsStates(next, prev) &&
    InProgressUtils.compareInProgressStates(next, prev)
  );
}

const dispatchActions: ReduxDispatchProps = {
  onLoadClients: addSenderArgument(sender, listOrganizationClients)
};
export default connect<
  ReduxStateProps,
  ReduxDispatchProps,
  ClientsCardProps,
  AppState
>(mapStateToProps, dispatchActions, null, {
  areStatesEqual
})(ClientsCard);
